import React, { FC } from "react"
import { ReactComponent as IconModel } from "icons/lib/model.svg"
import { Button } from "dash-styled"
import { ContactUsMessageType } from "../../../../../../../../Models/External/FeedbackModel"
import { ContactForm } from "../../../../../../../Common/Modal/ContactForm"
import { useBoolean } from "../../../../../../../../Hooks/useBoolean"

export interface EmptyTrainingViewProps {
    appID: string
    onAdd?: () => void
}

export const EmptyTrainingView: FC<EmptyTrainingViewProps> = ({
    appID,
    onAdd
}) => {
    const [isModalOpen, openModal, closeModal] = useBoolean(false)

    return (
        <div className="w-full flex flex-col items-center mt-12">
            <IconModel className="w-48 h-48 mb-8 text-smoke-800 opacity-30" />
            <h2 className="text-rhino-900 text-center font-semibold text-xl mb-4">
                Improve the quality, cost and speed
                <br />
                of your unstructured data processing with AI
            </h2>
            <p className="text-smoke-610 text-center my-0">
                Bring your own model or use one of
                <br />
                ours — for pre-processing, active
                <br />
                learning, model-based QA, etc.
            </p>
            {onAdd === undefined ? (
                <Button className="w-auto mt-8 px-12" onClick={openModal}>
                    Find out more
                </Button>
            ) : (
                <Button className="w-auto mt-8 px-12" onClick={onAdd}>
                    Add new AI training
                </Button>
            )}
            {isModalOpen && (
                <ContactForm
                    prefilledMessage="I'd like to learn more about using AI training in my project"
                    extraData={{
                        appID,
                        type: ContactUsMessageType.AITrainings
                    }}
                    onClose={closeModal}
                />
            )}
        </div>
    )
}
